<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de identificación</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id && tipo.Nombre == enumeraciones.tiposDeSelect.Todos.Nombre" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los juzgados</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todas.Id && tipo.Nombre == enumeraciones.tiposDeSelect.Todas.Nombre" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todas.Nombre}} las áreas</option>
        <option v-for="TipoIdentificacion in TiposIdentificacion" :key="TipoIdentificacion.TipoIdentificacionId" :value="TipoIdentificacion.TipoIdentificacionId">{{TipoIdentificacion.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        TiposIdentificacion: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_PJ_Catalogo_Establecer038TiposIdentificacion", parametros);
    },
    methods: {
      cargaCatalogoDeTiposIdentificacion: function() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba

        axios.post(api.conexion + api.PJ.catalogos.C038TiposIdentificacion, this.parametros)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {              
              this.TiposIdentificacion = respuesta.data.TiposIdentificacion;
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }

        this.$store.dispatch("A_PJ_Catalogo_Establecer038TiposIdentificacion", parametros);
        this.$emit("valorParaElPadre", evento);
      }
    },
    created() {
      this.cargaCatalogoDeTiposIdentificacion();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/038TiposIdentificacion.vue